module.exports = __webpack_public_path__ + "static/media/OurAchievements.b2ae8f6c.svg";